import React, { Dispatch, SetStateAction } from 'react';
import { StoryElement } from './story';
import { EditingStoryElement } from './editingStory';
import { Story } from '../../../schema';

export const StoryBox = (props: {
  story: Story;
  editingStoryId: string | null;
  setEditingStoryId: Dispatch<SetStateAction<string | null>>;
  setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const isEditing = props.editingStoryId === props.story.id;

  return (
    <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 mt-12">
      <hr className="w-[80%] mx-auto h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" />
      {!isEditing && (
        <StoryElement
          story={props.story}
          setEditing={(editing) => props.setEditingStoryId(editing ? props.story.id : null)}
          isAnyStoryEditing={props.editingStoryId !== null}
        />
      )}
      {isEditing && (
        <EditingStoryElement
          story={props.story}
          setHasChanges={props.setHasChanges}
          setEditing={(editing) => props.setEditingStoryId(editing ? props.story.id : null)}
        />
      )}
    </div>
  );
};
